import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ModuleGuard } from '@/components/module-guard'

export const Route = createFileRoute('/hr/expense-claims')({
  component: ExpenseClaimsLayout,
})

function ExpenseClaimsLayout() {
  return (
    <ModuleGuard moduleKey="hr">
      <Outlet />
    </ModuleGuard>
  )
}
